import React, { useEffect } from 'react';
import { Modal, Form, Input, Space, Button } from 'antd';
import { toast } from 'react-toastify';
import { renvoyer } from '../../services/attestationDigitaleService';
import { useTranslation } from 'react-i18next';

export default function RenvoyerAttestationModal({ open, attestation, onClose, onEnvoye }) {
  const { t } = useTranslation('attestationsDigitales');
  const [form] = Form.useForm();

  useEffect(() => {
    if (open && attestation) {
      form.setFieldsValue({
        email: attestation.souscripteurEmail || '',
        telephone: attestation.souscripteurTelephone || '',
      });
    }
  }, [open, attestation, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await renvoyer(attestation.trackingId, values);
      toast.success(t('renvoyer.succes'));
      onEnvoye();
    } catch (e) {
      if (e?.errorFields) return;
      toast.error(e?.response?.data?.message || t('renvoyer.erreur'));
    }
  };

  return (
    <Modal
      title={t('renvoyer.titre', { numero: attestation?.numeroAttestation || '' })}
      open={open}
      onCancel={onClose}
      width={420}
      footer={
        <Space>
          <Button onClick={onClose}>{t('actions.annuler')}</Button>
          <Button type="primary" onClick={handleSubmit}
            style={{ background: '#1a6b3c', borderColor: '#1a6b3c' }}>
            {t('actions.renvoyer')}
          </Button>
        </Space>
      }
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item name="email" label={t('renvoyer.email')}>
          <Input type="email" placeholder={t('emettre.emailExemple')} />
        </Form.Item>
        <Form.Item name="telephone" label={t('renvoyer.telephone')}>
          <Input placeholder="+228 XX XX XX XX" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
